module.exports = __webpack_public_path__ + "img/clouding.c38235f5.jpeg";